import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  News,
  Trust,
  Stats,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import bg from "../img/bg.mp4";
import { useNavigate } from "react-router";
import { Grid } from "@mui/material";
import { FeatureCard } from "../components/Hero";
import { FeatureCardSmall, ContentSideBySideCustom } from "../components/Hero";
import CellTowerIcon from "@mui/icons-material/CellTower";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "react-lottie";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import { Collage, OurProcess, YouWillGet } from "./Sections";

export default function Services() {
  useEffect(() => {
    axios
      .get(API_URL + "get_news")
      .then((res) => {
        setNews(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setNews([]);
      });
    axios
      .get(API_URL + "get_gallery")
      .then((res) => {
        setGallery(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching gallery:", err);
        setGallery([]);
      });
  }, []);
  const [news, setNews] = useState([]);
  const [gallery, setGallery] = useState([]);

  const navigate = useNavigate();

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <video
          src={bg}
          type="video/mp4"
          autoPlay
          loop
          muted
          id="video"
          className="video"
        />

        <div style={{ backgroundColor: "white" }}>
          <div
            style={{
              height: "80vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: "70px",
                  fontSize: "65px",
                  color: "white",
                  fontWeight: 600,
                  zIndex: 999,
                }}
              >
                IT Consulting Services
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "5px 0px 5px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: "45px",
                  color: "white",
                  zIndex: 999,
                }}
              >
                Driving value through innovative IT Solutions.
              </div>
            </div>
          </div>
          <News
            gallery={gallery.map((gall, index) => ({
              subtitle: gall["subtitle"],
              title: gall["title"],
              image: API_URL + gall["image"],
              page: gall["page"],
            }))}
          />
          <div style={{ height: "50px" }} />

          <div
            className={"anigrad"}
            style={{
              paddingTop: "50px",
              paddingBottom: "100px",
            }}
          >
            <TabContext value={value}>
              {!state.auth.isMobile ? (
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "50px",
                    background: "transparent",
                    maxWidth: "100vw",
                  }}
                >
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab
                      label="Cloud Solutions"
                      value="1"
                      style={{ fontSize: "20px", color: "white" }}
                    />

                    <Tab
                      label="Cybersecurity"
                      value="2"
                      style={{ fontSize: "20px", color: "white" }}
                    />
                    <Tab
                      label="IT Consulting"
                      value="3"
                      style={{ fontSize: "20px", color: "white" }}
                    />
                    <Tab
                      label="Managed IT Services"
                      value="4"
                      style={{ fontSize: "20px", color: "white" }}
                    />
                    <Tab
                      label="Software Development"
                      value="5"
                      style={{ fontSize: "20px", color: "white" }}
                    />
                    <Tab
                      label="Staffing Solutions"
                      value="6"
                      style={{ fontSize: "20px", color: "white" }}
                    />
                  </TabList>
                </Box>
              ) : (
                <div style={{ marginBottom: "-100px" }} />
              )}
              <TabPanel value="1">
                <ContentSideBySideCustom
                  background={"transparent"}
                  titleColor={"white"}
                  subtitleColor={"#ddd"}
                  titleFontSize={"22px"}
                  subtitleFontSize={"20px"}
                  title="Empower Your Business with Cloud Solutions"
                  subtitle="Transform your business with our cutting-edge cloud solutions. We provide scalable, secure, and cost-effective cloud services tailored to your needs. Whether you're looking to migrate to the cloud, optimize your existing cloud infrastructure, or leverage cloud-native technologies, our experts ensure seamless integration and maximum performance. From public and private clouds to hybrid models, we help you unlock the full potential of cloud computing."
                  image={
                    <img
                      style={{
                        height: "50vh",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      src={require("../img/cloud1.png")}
                    ></img>
                  }
                />
              </TabPanel>
              <TabPanel value="2">
                <ContentSideBySideCustom
                  background={"transparent"}
                  titleColor={"white"}
                  subtitleColor={"#ddd"}
                  titleFontSize={"22px"}
                  subtitleFontSize={"20px"}
                  title="Protect Your Business with Advanced Cybersecurity"
                  subtitle="In today’s digital landscape, cybersecurity is more critical than ever. Our comprehensive cybersecurity solutions safeguard your business from evolving threats. We offer end-to-end protection, including threat detection, vulnerability assessments, penetration testing, and incident response. With our proactive approach, we ensure your data, systems, and networks remain secure, compliant, and resilient against cyberattacks."
                  image={
                    <img
                      style={{
                        height: "50vh",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      src={require("../img/cloud2.png")}
                    ></img>
                  }
                />
              </TabPanel>
              <TabPanel value="3">
                <ContentSideBySideCustom
                  background={"transparent"}
                  titleColor={"white"}
                  subtitleColor={"#ddd"}
                  titleFontSize={"22px"}
                  subtitleFontSize={"20px"}
                  title="Strategic IT Consulting for Business Growth"
                  subtitle="Our IT consulting services are designed to align technology with your business goals. We provide expert guidance on IT strategy, digital transformation, and technology adoption. Whether you're planning to modernize your IT infrastructure, implement new technologies, or optimize existing systems, our consultants deliver actionable insights and tailored solutions to drive growth and innovation."
                  image={
                    <img
                      style={{
                        height: "50vh",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      src={require("../img/cloud6.png")}
                    ></img>
                  }
                />
              </TabPanel>
              <TabPanel value="4">
                <ContentSideBySideCustom
                  background={"transparent"}
                  titleColor={"white"}
                  subtitleColor={"#ddd"}
                  titleFontSize={"22px"}
                  subtitleFontSize={"20px"}
                  title="Streamline Operations with Managed IT Services"
                  subtitle="Focus on your core business while we handle your IT needs. Our managed IT services provide 24/7 monitoring, maintenance, and support for your IT infrastructure. From network management and data backup to helpdesk support and system updates, we ensure your IT environment runs smoothly and efficiently. Our proactive approach minimizes downtime, reduces costs, and enhances productivity."
                  image={
                    <img
                      style={{
                        height: "50vh",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      src={require("../img/cloud4.png")}
                    ></img>
                  }
                />
              </TabPanel>
              <TabPanel value="5">
                <ContentSideBySideCustom
                  background={"transparent"}
                  titleColor={"white"}
                  subtitleColor={"#ddd"}
                  titleFontSize={"22px"}
                  subtitleFontSize={"20px"}
                  title="Build Scalable Solutions with Custom Software Development"
                  subtitle="Our custom software development services empower businesses with tailored solutions that meet their unique needs. From web and mobile applications to enterprise software and APIs, we deliver scalable, secure, and user-friendly solutions. Our agile development process ensures rapid delivery, continuous improvement, and seamless integration with your existing systems."
                  image={
                    <img
                      style={{
                        height: "50vh",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      src={require("../img/cloud5.png")}
                    ></img>
                  }
                />
              </TabPanel>
              <TabPanel value="6">
                <ContentSideBySideCustom
                  background={"transparent"}
                  titleColor={"white"}
                  subtitleColor={"#ddd"}
                  titleFontSize={"22px"}
                  subtitleFontSize={"20px"}
                  title="Empower Your Business with Expert Staffing Solutions"
                  subtitle="We provide tailored staffing solutions to help businesses find top talent quickly and efficiently. 
                  Whether you need contract, temporary, or full-time professionals, our industry-specific recruitment 
                  ensures the right fit for your team. With a streamlined hiring process, we reduce recruitment time 
                  while maintaining high-quality standards, empowering your workforce for growth and success."
                  image={
                    <img
                      style={{
                        height: "50vh",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      src={require("../img/cloud2.png")}
                    ></img>
                  }
                />
              </TabPanel>
            </TabContext>
          </div>
          <OurProcess
            invert
            step1={"Understand Your Business Needs and Goals"}
            step1description={
              "We begin by thoroughly understanding your business objectives, challenges, and technical requirements. Our team collaborates with you to define clear goals, whether it's improving operational efficiency, enhancing customer experiences, or driving innovation. This foundational step ensures our solutions are aligned with your vision and deliver measurable results."
            }
            step2={"Design and Develop Tailored IT Solutions"}
            step2description={
              "Leveraging cutting-edge technologies and industry best practices, we design and develop customized IT solutions that address your unique needs. From software development to system integration, our team ensures scalability, reliability, and security. We focus on creating solutions that not only solve current challenges but also future-proof your business."
            }
            step3={"Implement and Integrate Seamlessly"}
            step3description={
              "Our experts handle the end-to-end implementation and integration of IT solutions into your existing infrastructure. We ensure minimal disruption to your operations while maximizing efficiency and performance. Whether it's deploying cloud-based systems, automating workflows, or setting up enterprise software, we deliver seamless integration for a smooth transition."
            }
            step4={"Optimize and Support for Continuous Improvement"}
            step4description={
              "Our partnership doesn’t end with implementation. We provide ongoing support, monitoring, and optimization to ensure your IT solutions continue to perform at their best. Through regular updates, performance analysis, and proactive maintenance, we help you stay ahead of the curve and adapt to evolving business needs."
            }
          />
          <div
            className="anigrad"
            style={{
              width: "100%",
              padding: "50px",
            }}
          >
            <div
              style={{
                borderRadius: "25px",
                fontSize: state.auth.isMobile ? "30px" : "40px",
                color: "white",
                fontWeight: 600,
                paddingTop: "50px",
              }}
            >
              Managed IT Services and Solutions
            </div>

            <div style={{ height: "50px" }} />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Grid
                style={{
                  width: state.auth.isMobile ? "100%" : "70%",
                  display: "flex",
                  justifyContent: "center",
                }}
                container
                spacing={3}
              >
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <FeatureCardSmall
                    title={"Strategic consulting"}
                    text={""}
                    icon={
                      <BusinessCenterIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Implementation"}
                    text={""}
                    icon={
                      <BuildIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Design and Development"}
                    text={""}
                    icon={
                      <DesignServicesIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Integration and Migration"}
                    text={""}
                    icon={
                      <SyncAltIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
              </Grid>
            </div>
            <div style={{ height: "50px" }} />

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Grid
                style={{
                  width: state.auth.isMobile ? "100%" : "70%",
                  display: "flex",
                  justifyContent: "center",
                }}
                container
                spacing={3}
              >
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <FeatureCardSmall
                    title={"Automation"}
                    text={""}
                    icon={
                      <AutoAwesomeMotionIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Support services"}
                    text={""}
                    icon={
                      <SupportAgentIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Advisory services"}
                    text={""}
                    icon={
                      <QuestionAnswerIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"ORG Health check Services"}
                    text={""}
                    icon={
                      <HealthAndSafetyIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
              </Grid>
            </div>
            <div style={{ height: "100px" }} />
            <div style={{ marginLeft: "-50px" }}>
              <YouWillGet
                title1={"Customized IT Solutions"}
                title2={"Operational Efficiency"}
                title3={"Effective Technology"}
                title4={"24/7 Support"}
                title5={"Scalable Systems"}
              />
            </div>
            <div
              style={{
                borderRadius: "25px",
                fontSize: state.auth.isMobile ? "30px" : "40px",
                color: "white",
                paddingTop: "50px",
                fontWeight: 600,
              }}
            >
              Our Technological Expertise
            </div>
            <div style={{ height: "50px" }} />

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Grid
                style={{
                  width: state.auth.isMobile ? "100%" : "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
                container
                spacing={3}
              >
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <FeatureCardSmall
                    title={"AI & ML - LLM"}
                    text={""}
                    icon={
                      <EqualizerIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Data & Analytics"}
                    text={""}
                    icon={
                      <AssignmentIndIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>

                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"RPA"}
                    text={""}
                    icon={
                      <AutoGraphIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <FeatureCardSmall
                    title={"Low Code"}
                    text={"Low code "}
                    icon={
                      <BuildIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
              </Grid>
            </div>
            <div style={{ height: "50px" }} />

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Grid
                style={{
                  width: state.auth.isMobile ? "100%" : "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
                container
                spacing={3}
              >
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <FeatureCardSmall
                    title={"Open Source"}
                    text={""}
                    icon={
                      <BuildIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"CRM"}
                    text={""}
                    icon={
                      <EngineeringIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"ERP"}
                    text={""}
                    icon={
                      <PersonIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={10}
                  sm={10}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {" "}
                  <FeatureCardSmall
                    title={"Cloud"}
                    text={""}
                    icon={
                      <EngineeringIcon
                        style={{
                          fontSize: "50px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                    }
                    gradient={
                      "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                    }
                  />
                </Grid>
              </Grid>
            </div>

            <div style={{ height: "50px" }} />
          </div>
          {/* <div
            style={{
              fontSize: state.auth.isMobile ? "30px":"40px",
              color: themeStyle.primaryColor,
              zIndex: 999,
            }}
          >
            What's New On Our Minds
          </div>
          <Gallery
            gallery={news.map((ne, index) => ({
              subtitle: ne["subtitle"],
              title: ne["title"],
              image: API_URL + ne["image"],
            }))}
          /> */}
          <div
            style={{
              padding: "50px",
              paddingBottom: "200px",
              fontSize: "35px",
              fontWeight: 600,
              marginBottom: "-100px",
              color: themeStyle.primaryColor,
              zIndex: 999,
            }}
          >
            Who we have been working for and our expertise
          </div>
          <ThreeSideBySide
            title1="For Startups"
            subtitle1={
              <div
                style={{
                  textAlign: "left",
                  fontSize: "18px",
                  fontWeight: "normal",
                }}
              >
                Ensure your startup's growth with a strong technical foundation, designed
                for scalability, reliability, and long-term success. Our robust tech
                stack and expertly crafted systems empower your product to seamlessly
                handle increasing user demand without compromising on performance.
              </div>
            }
            title2="For Businesses"
            subtitle2={
              <div
                style={{
                  textAlign: "left",
                  fontSize: "18px",
                  fontWeight: "normal",
                }}
              >
                Achieve greater scalability, automation, and enhanced productivity to stay
                competitive and meet growing demands. By leveraging advanced technologies
                and streamlined processes, your business can operate efficiently,
                reduce manual effort, and thrive in a dynamic market.
              </div>
            }
            title3="For Enterprises & Startups"
            subtitle3={
              <div
                style={{
                  textAlign: "left",
                  fontSize: "18px",
                  fontWeight: "normal",
                }}
              >
                Ensure ecosystem stability and efficiency with continuous delivery and integration,
                allowing for seamless updates and faster time-to-market. By automating testing,
                deployment, and monitoring, you can maintain system reliability and reduce errors.
              </div>
            }
            image1={require("../img/cloud7.png")}
            image2={require("../img/cloud8.png")}
            image3={require("../img/cloud9.png")}
          />
          <div style={{ marginBottom: "-50px" }} />
          <ContentSideBySideInv
            title="Our Approach"
            subtitle={
              <div style={{}}>
                {" "}
                At CGT Solutions, we distinguish ourselves as your go-to partner for IT solutions
                by blending innovation, expertise, and a customer-centric approach.
                Our customized strategies ensure the seamless integration of technology
                with your business needs, optimizing both efficiency and productivity.
                Backed by a team of skilled professionals, we deliver scalable, cost-effective
                solutions designed to adapt to your growth. Whether it’s workforce management
                or cutting-edge IT support, CGT Solutions empowers your organization to excel
                in today’s competitive landscape.
              </div>
            }
            image={
              <img
                style={{ width: "100%", marginTop: "15px" }}
                src={require("../img/111.jpg")}
              />
            }
          />
        </div>
        <div style={{ height: "100px" }} />
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Trust />
        </div>
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Collage />
        </div>
        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
